/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/RelatedProducts/RelatedProducts',[
    'jquery',
    'global/all',
    'plugins/slick'
], function ($, Roc, Slick) {
    'use strict';

    function init() {
        var carouselData = {
            animationSpeed: 1500,
            autoRotate: false,
            autoRotateSpeed: 1000,
            nofVisible: 4,
            scrollNumber: 1,
            showNextPrevButtons: true,
            isCircular: true,
            showDots: false
        };

        $('.hawk-recommendation-list').slick({
            speed: carouselData.animationSpeed,
            autoplay: carouselData.autoRotate,
            autoplaySpeed: carouselData.autoRotateSpeed,
            vertical: false,
            slidesToShow: carouselData.nofVisible,
            slidesToScroll: carouselData.scrollNumber,
            arrows: carouselData.showNextPrevButtons,
            //nextArrow: '<button type="button" class="hawk-carousel-next"><span>Next</span></a>',
            //prevArrow: '<button type="button" class="hawk-carousel-prev"><span>Previous</span></a>',
            infinite: false,
            dots: carouselData.autoRotateshowDots,
            //variableWidth: (!item.isVertical),
            slide: '.hawk-recommendation-item',
            //pauseOnDotsHover: true,
            //pauseOnHover: true,
            //mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        arrows: carouselData.showNextPrevButtons,
                        dots: carouselData.showDots
                    }
                },
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        arrows: carouselData.showNextPrevButtons,
                        dots: carouselData.showDots
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: carouselData.showNextPrevButtons
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: carouselData.showNextPrevButtons
                    }
                },
                {
                    breakpoint: 240,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: carouselData.showNextPrevButtons
                    }
                }
            ]
        });
    };

    function reloadWidget() {
        var divTitle = $(".hawk-recommendation .itemTitle");
        _.each(divTitle, function (title) {
            var titleText = $(title).text();
            $(title).html(titleText);
        });
    }
    
    var RelatedProducts = {
        init: init,
        reloadWidget: reloadWidget
    };

    Roc.Logger.debug('RelatedProducts.js Loaded:', RelatedProducts);

    return RelatedProducts;
});
